// for story brevity, see examples in this repo
export const disableControl = {
  table: {
    disable: true,
  },
};

// reusable lorem ipsum content we should prefer in stories
export const LoremIpsum = {
  SHORT: "Lorem Ipsum",
  MEDIUM: "Lorem ipsum dolor sit amet.",
  LONG: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent leo tellus, sollicitudin eu lorem nec, dictum pellentesque magna. Nullam sed.",
};
export type LoremIpsumKey = typeof LoremIpsum;
